import { combineReducers } from 'redux';
import defaults from './defaultTemplate/reducer';
import { templateResource } from './templateResource';
export default combineReducers({
  ...templateResource.detailReducer,
  ...templateResource.listReducer,
  defaults
});